import { RootReducer } from '../../rootReducer';

export const selectUnsavedChanges = (state: RootReducer) => state.appReducer.unsavedChanges;
